/* istanbul ignore file */

import { createUseStyles } from '@glu/theming';

const styles = ({
  palette: {
    grey: { G600 }
  }
}) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  label: {
    color: G600,
    fontSize: 12,
    fontWeight: 700,
    marginBottom: 5,
    textTransform: 'uppercase'
  }
});

export default createUseStyles(styles);
